import { render, staticRenderFns } from "./NavixyUserNotContractList.vue?vue&type=template&id=c0671c90&"
import script from "./NavixyUserNotContractList.vue?vue&type=script&lang=js&"
export * from "./NavixyUserNotContractList.vue?vue&type=script&lang=js&"
import style0 from "./NavixyUserNotContractList.vue?vue&type=style&index=0&id=c0671c90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports